<template>
  <el-dialog
    title="校验码"
    :visible="AccessVisi"
    width="35%"
    :close-on-click-modal="false"
  >
    <el-form ref="formRef" :model="formInItem" :rules="rules" style="margin-top:20px">
      <el-form-item prop="accessCode">
        <el-input v-model="formInItem.accessCode" placeholder="设置自定义校验码"></el-input>
      </el-form-item>
    </el-form>
      <h2>提示：</h2>
      <p>1.我们不会向签署方发送校验码，您需在合同发起后，自行将校验码发送给签署方。</p>
      <p>2.校验码可包含字母（不区分大小写）和数字。</p>
      <p>3.设置完成后，您可在合同详情中查看访问码。</p>
    <span slot="footer">
      <el-button size="small" @click="closePup">取 消</el-button>
      <el-button type="primary" size="small" @click="setConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    AccessVisi: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      formInItem: {
        accessCode: '',
      },
      rules: {
        accessCode: [{ validator: this.verifyAccessCode, trigger: 'change' }]
      }
    }
  },
  methods: {
    verifyAccessCode (rule, value, callback) {
      const CODERXG = /^[a-zA-Z0-9]{6}$/;
      if (value === '') {
        callback(new Error(this.$t('errors.AccessCode')));
      } else if (!CODERXG.test(value)) {
        callback(new Error(this.$t('errors.AccessCode')));
      } else {
        callback();
      }
    },
    closePup () {
      this.$emit("PupConfirm", false);
    },
    setConfirm () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("PupConfirm", this.formInItem);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"])
  },
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// pages/initiation/components/accessPup.vue